import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { Checkbox, Chip, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from '@mui/material';
import { Close, SearchOutlined } from '@mui/icons-material';
import { font } from '../../styles/font';
import { useEffect, useState } from 'react';
import { useApplicationContext } from '../../context/ApplicationContext';
import useErrorHandler from '../../api/errorHandler/useErrorHandler';
import { HttpStatusCode } from 'axios';
import { addProject_API, getProjectCategoryList_API, getProjectList_API, getProjectSubcategoryList_API } from '../../api/controller/ProjectController';
import { Entity_Label, Severity } from '../../constant/ApplicationVariables';
import { useTranslation } from 'react-i18next';
import { ProjectCustomIcon } from '../styled/CustomIcons';

export default function CreateProgramComponent({ open, handleClose, handleContinue }) {
    const { projectList, setProjectList, handleSnackbar, } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const { t } = useTranslation('translation', { keyPrefix: 'project' });

    const [projectData, setProjectData] = useState(null);
    const [error, setError] = useState(null);
    const [activeProjectCategory, setActiveProjectCategory] = useState(null);
    const [activeProjectSubcategory, setActiveProjectSubcategory] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);

    const toggleDrawer = () => {
        handleClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateInputs();
    }

    // const handleChangeProjectCategory = (event) => {
    //     setActiveProjectCategory(event.target.value);
    // }

    // const handleChangeProjectSubcategory = (event) => {
    //     setActiveProjectSubcategory(event.target.value);
    // }


    const validateInputs = () => {
        let isValid = true;
        const errorObject = {};

        if (!projectData?.name || projectData?.name?.length < 3 || projectData?.name?.length > 20) {
            errorObject.name = "Name must be between 3 and 20 characters long.";
            isValid = false;
        } else {
            delete errorObject.name;
        }

        if (!projectData?.description) {
            errorObject.description = "Description is required.";
            isValid = false;
        } else {
            delete errorObject.description;
        }

        if (!projectData?.categoryName) {
            errorObject.categoryName = "Category is required.";
            isValid = false;
        } else {
            delete errorObject.categoryName;
        }

        if (projectData?.categoryName && !projectData?.subCategoryName) {
            errorObject.subCategoryName = "Sub Category is required.";
            isValid = false;
        } else {
            delete errorObject.subCategoryName;
        }

        setError(errorObject);
        return isValid && handleCreate();
    };

    const handleChange = (e) => {
        if (e.target.name === "categoryName" || e.target.name === "subCategoryName") {
            setProjectData({ ...projectData, [e.target.name]: e.target.value?.name });
        } else {
            setProjectData({ ...projectData, [e.target.name]: e.target.value });
        }
    }


    const handleCreate = () => {
        handleContinue(projectData);
    }

    const handleGetProjectList = async () => {
        try {
            setIsLoading(true);

            const response = await getProjectList_API();
            console.log(response, "response handleGetProjectList")

            if (response) {
                errorHandler(response, setIsLoading);
            }

            if (response.status === HttpStatusCode.Ok) {
                setProjectList(response.data);
            }

        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        }
    }


    const handleGetCategoryList = async () => {
        try {
            setIsLoading(true);

            const response = await getProjectCategoryList_API();

            if (response.status === HttpStatusCode.Ok) {
                setCategoryList(response.data);
                setProjectData({ "name": "", "description": "", "categoryName": response.data[0]?.name, "subCategoryName": "" });
                // setProjectData({ ...projectData, "categoryName": response.data[0]?.name });

                // handleSnackbar(response.message, Severity.success);
            }

            if (response) {
                errorHandler(response);
            }

            setTimeout(() => {
                setIsLoading(false);
            }, 1000);

            console.log(response, "categoryreponse data")
        } catch (error) {
            console.log(error, "categoryreponse errorr")
        }
    }

    const handleGetsubCategoryList = async () => {
        try {


            let query = `parentName=${projectData?.categoryName}`;

            const response = await getProjectSubcategoryList_API(query);

            if (response.status === HttpStatusCode.Ok) {
                setSubCategoryList(response.data);
                setProjectData({ ...projectData, "subCategoryName": response.data[0]?.name });

                // handleSnackbar(response.message, Severity.success);
            }

            if (response) {
                errorHandler(response);
            }


            console.log(response, "subcategoryreponse data")
        } catch (error) {
            console.log(error, "subcategoryreponse errorr")
        }
    }

    useEffect(() => {
        handleGetProjectList();
        // handleGetCategoryList();
    }, []);

    useEffect(() => {
        if (projectData?.categoryName) {
            // handleGetsubCategoryList();
        }
    }, [projectData?.categoryName]);



    console.log(projectData, "projectData1")

    const DrawerList = (
        <Box sx={{ width: 420 }} role="presentation" className="flex flex-col h-full">
            <Box className="flex items-center justify-between px-4 py-2 border-b-2">
                <Typography fontSize={font.size.fs_4} color="textPrimary">{"Create Program"}</Typography>
                <IconButton onClick={() => toggleDrawer()}>
                    <Close />
                </IconButton>
            </Box>

            <Box component="form" onSubmit={handleSubmit} className="flex-1 flex flex-col gap-4 px-4 py-4 overflow-y-auto">


                <FormControl required fullWidth>
                    <FormLabel htmlFor="name">{t("nameText")}</FormLabel>
                    <TextField
                        id="name"
                        name="name"
                        placeholder="Enter name"
                        sx={{ fontSize: font.size.fs_4 }}
                        value={projectData?.name}
                        onChange={handleChange}
                        error={error?.name ? true : false}
                        helperText={error?.name && error?.name}
                    />
                </FormControl>

                <FormControl required fullWidth>
                    <FormLabel htmlFor="description">{t("descriptionText")}</FormLabel>
                    <TextField
                        id="description"
                        name="description"
                        placeholder="Enter description"
                        multiline
                        minRows={4}
                        sx={{ fontSize: font.size.fs_4 }}
                        value={projectData?.description}
                        onChange={handleChange}
                        error={error?.description ? true : false}
                        helperText={error?.description && error?.name}
                    />
                </FormControl>

                {/* project list container */}
                <Box className="flex-1 flex flex-col gap-4 ">



                    <FormControl required fullWidth>
                        <FormLabel htmlFor="description">{Entity_Label.project}</FormLabel>
                        <Box className="flex flex-col">

                            {/* search container */}
                            <Box className="flex flex-col">
                                <TextField
                                    type="search"
                                    placeholder="Search"
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchOutlined />
                                                </InputAdornment>
                                            ),
                                        }
                                    }}

                                />
                            </Box>

                            {/* list of projects */}
                            <Box className="flex-1 flex flex-col gap-0 overflow-hidden">

                                <Box className=" flex items-center justify-between px-4 py-2">
                                    <FormControl >
                                        <FormControlLabel
                                            label={"Select All"}
                                            control={<Checkbox />}
                                        />
                                    </FormControl>

                                    <Chip label={`0 / ${projectList?.length}`} />
                                </Box>


                                <Box className="flex-1 flex flex-col gap-0 overflow-y-auto">
                                    {projectList?.map((item, index) => {
                                        return (
                                            <MenuItem key={index} value={item?.name} onClick={() => { }}>
                                                <FormControl fullWidth>
                                                    <FormControlLabel
                                                        label={
                                                            <Box className="flex items-center gap-1">
                                                                <ProjectCustomIcon sx={{ color: theme.palette.secondary.main, fontSize : font.size.fs_4 }} />
                                                                <Typography>{item?.name}</Typography>
                                                            </Box>
                                                        }
                                                        control={<Checkbox />}
                                                    />
                                                </FormControl>
                                            </MenuItem>
                                        )
                                    })}
                                </Box>
                            </Box>





                        </Box>
                    </FormControl>



                </Box>
            </Box>

            <Box className="flex items-center gap-4 px-4 py-4 border-t-2">
                <Button fullWidth variant="outlined" disabled={isLoading} onClick={() => toggleDrawer()}>{t("discardText")}</Button>
                <Button fullWidth type="submit" variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText }} disabled={isLoading} onClick={handleCreate}>{t("createText")}</Button>
            </Box>

        </Box>
    );

    return (
        <Box>
            <Drawer open={open} onClose={handleClose} anchor="right" variant="temporary">
                {DrawerList}
            </Drawer>
        </Box>
    );
}
